class ProductBundleManager {
    constructor() {
        this.productForms = document.querySelectorAll('form[data-block-product-form]');
        this.productBundleDivs = document.querySelectorAll('.product-bundle');
        this.productIds = [];
    }

    init() {
        this.collectProductIds();
        this.appendInputsToBundles();
    }

    collectProductIds() {
        this.productForms.forEach(form => {
            const productId = form.getAttribute('data-variantid');
            if (productId) {
                this.productIds.push({
                    id: productId,
                    quantity: 1
                });
            }
        });
    }

   appendInputsToBundles() {
        this.productBundleDivs.forEach(bundleDiv => {
            this.productIds.forEach((product,index) => {
                bundleDiv.appendChild(this.createHiddenInput(`items[${index}][id]`, product.id, `variant-id-${product.id}`, 'product-variant-id'));
                bundleDiv.appendChild(this.createHiddenInput(`items[${index}][quantity]`, product.quantity, 'Quantity'));
            });
        });
    }

    createHiddenInput(name, value, id, className = '') {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.id = id;
        if (className) input.className = className;
        return input;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const productBundleManager = new ProductBundleManager();
    productBundleManager.init();
});
